import { CoachingCaseCard } from '@euler/model/coaching';
import { useCallback, useEffect, useState } from 'react';

export type CaseListState =
  | { kind: 'loading' }
  | { kind: 'failed' }
  | { kind: 'ready'; cases: CoachingCaseCard[] };

/**
 * A whole list of cases, loaded at once and again whenever `load` changes
 * (memoize it on what it loads).
 */
export function useCaseList(
  load: () => Promise<CoachingCaseCard[]>,
  /** Names the list in the log when it fails to load. */
  name: string,
): { state: CaseListState; reload: () => void } {
  const [state, setState] = useState<CaseListState>({ kind: 'loading' });
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    setState({ kind: 'loading' });
    load()
      .then(cases => {
        if (active) setState({ kind: 'ready', cases });
      })
      .catch(error => {
        console.error(`coaching ${name} failed`, error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [load, name, reloadKey]);
  return { state, reload };
}
